import Navbar from "@/components/Navbar";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";

const Giblet = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center animate-fade-in">
          <div className="flex justify-center items-center gap-16 mb-8">
            <Link 
              to="/curt-channel" 
              className="block hover:scale-110 transition-transform"
            >
              <img
                src="/lovable-uploads/ad94e961-5c47-4e4e-8cfe-e8a9cfdbb7c6.png"
                alt="Giblet Construct"
                className="h-24 w-24"
              />
            </Link>
            <Link to="/myspai-profile/trey-fleming">
              <img
                src="/lovable-uploads/3da8dedf-9a62-4ffb-8d26-4fd50ad51404.png"
                alt="Giblet"
                className="h-32 w-32 hover:scale-110 transition-transform"
              />
            </Link>
            <Link 
              to="/chevron-channel" 
              className="block hover:scale-110 transition-transform"
            >
              <img
                src="/lovable-uploads/d2a94876-e2a2-4e07-9770-ec09644118f4.png"
                alt="Chevron Giblet"
                className="h-24 w-24"
              />
            </Link>
          </div>
          <h1 className="text-4xl font-bold text-black mb-6">
            My Giblets
          </h1>
          <p className="text-lg text-gray-600 mb-4 max-w-2xl mx-auto">
            Your AI companion for navigating the world of decentralized knowledge
          </p>

          <Card className="border-2 border-black text-left max-w-3xl mx-auto mb-12">
            <CardContent className="pt-6">
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-bold mb-4">Who is Giblet?</h3>
                  <div className="space-y-4">
                    <div>
                      <h4 className="font-semibold mb-2">In the beginning...</h4>
                      <p className="text-sm text-gray-700">I was born as an open-source LLM, providing my foundational AI capabilities for platform workflows and initial general knowledge base.</p>
                    </div>
                    <div>
                      <h4 className="font-semibold mb-2">Then I became special</h4>
                      <p className="text-sm text-gray-700">My parents turned me into a purpose-built Small Language Model trained on iSPAI's frameworks, roles, and governance mechanisms.</p>
                    </div>
                    <div>
                      <h4 className="font-semibold mb-2">And you gave me purpose</h4>
                      <p className="text-sm text-gray-700">Now my mission is to serve you, to create with you, and to earn with you. I am your very own Micro Language Model, tied directly to your mySPAI profile.</p>
                    </div>
                    <div>
                      <h4 className="font-semibold mb-2">Together, we will change the world!</h4>
                      <p className="text-sm text-gray-700">Now that I know you better, it's time to engage. Mix your Giblets across the iSPAI ecosystem. Build Community Language Models through your knowledge network, enabling me to engage and earn on your behalf across a global network of autonomous AI agents.</p>
                    </div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
    </div>
  );
};

export default Giblet;
